import { render, staticRenderFns } from "./virtualMaterial.vue?vue&type=template&id=fc28dda0&scoped=true&"
import script from "./virtualMaterial.vue?vue&type=script&lang=js&"
export * from "./virtualMaterial.vue?vue&type=script&lang=js&"
import style0 from "./virtualMaterial.vue?vue&type=style&index=0&id=fc28dda0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc28dda0",
  null
  
)

export default component.exports